import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    flex: 1,
  },

  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral900,
  },

  bottomContainer: {
    maxWidth: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 20,
  },

  bankData: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 10,
  },

  note: {
    fontWeight: 700,
    fontSize: 10,
    textTransform: 'uppercase',
    marginBottom: 2,
    color: colors.neutral900,
  },

  noteContainer: {
    marginTop: 10,
  },

  productTable: {
    paddingHorizontal: 0,
    marginTop: 0,
  },

  productTablesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 20,
  },
});
